import { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../css/booking.css";
import TherapistCard from "../components/TherapistCard";
import Back from "../assets/images/backArrow.svg";
import DateCard from "../components/DateCard";
import TimeSlotCard from "../components/TimeSlotCard";
import instance from "../api/axios";
import {
  getAllTherapist,
  getAllTherapistInternalBooking,
  getTherapistInternalBooking,
} from "../api/route";
import mixpanel from "../mixpanel"
// import { CircularProgress } from "@mui/joy";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Popup from "../components/Popup";
import SessionDetail from "../components/SessionDetail/sessionDetail";
import AboutPhysica from "../components/About/aboutPhysica";
import useDraggableScroll from "../hooks";
import BackHeader from "../components/Home/BackHeader"
import StepIndicator from "../components/Home/StepIndicator";
import rightIcon from "../assets/images/right-arrow.png";
import Button from "../components/Button";
import { useParams } from "react-router-dom";

// Normalise slot objects so we can safely merge data from different endpoints
const normalizeSlot = (slot = {}) => {
  const time =
    slot.time ||
    slot.start_at ||
    slot.startAt ||
    slot.startTime ||
    slot.slot_time;
  const therapist_id =
    slot.therapist_id ??
    slot.therapistId ??
    slot.doctor_id ??
    slot.doctorId ??
    slot.dayschedule_id;

  const epochMs = time ? new Date(time).getTime() : null;

  return {
    ...slot,
    time,
    epochMs,
    therapist_id,
    blocked: slot.blocked ?? slot.isBlocked ?? false,
  };
};

const normalizeSlotsByDate = (slotsByDate = {}) =>
  Object.fromEntries(
    Object.entries(slotsByDate).map(([date, slots]) => [
      date,
      Array.isArray(slots) ? slots.map((s) => normalizeSlot(s)) : [],
    ])
  );


const SlotPage = () => {
  const { ref, onMouseDown, onMouseLeave, onMouseUp, onMouseMove } =
    useDraggableScroll();

  const todayDate = new Date().toLocaleString("en-US", {
    timeZone: "Asia/Kolkata",
  });
  const today = new Date(todayDate);
  const { partnerSlug } = useParams();

  const [showMore, setShowMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  //added by shiv
  const [showPopup, setShowPopup] = useState(false);
  const isFirstAllFetch = useRef(true);
  const latestFetchKeyRef = useRef(0);
  const blockedPollTimeoutRef = useRef(null);
  const therapistBlockedPollTimeoutRef = useRef(null);

  const [Therapist, setTherapists] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState();
  const [selectedAllDoctorId, setSelectedAllDoctorId] = useState();
  const [selectedDoctorMeta, setSelectedDoctorMeta] = useState(null);
  const [allTimeSlotsByDate, setAllTimeSlotsByDate] = useState({});     // for “ALL Available” mode
  const [therapistSlotsByDate, setTherapistSlotsByDate] = useState({}); // for single therapist mode
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [blockedRequestId, setBlockedRequestId] = useState(null);
  const [therapistBlockedRequestId, setTherapistBlockedRequestId] = useState(null);
  const [selectedDate, setselectedDate] = useState(
    today.toISOString().split("T")[0]
  );
  const [allAvailable, setAllAvailable] = useState([]);
  const [showTherapistSection, setShowTherapistSection] = useState(false);

  const [morningSlots, setMorningSlots] = useState(false);
  const [noonSlots, setNoonSlots] = useState(false);
  const [eveningSlots, setEveningSlots] = useState(false);
  const getUser = sessionStorage.getItem("user");
  const { pinCode } = JSON.parse(getUser);

  const [morningAllSlots, setMorningAllSlots] = useState(false);
  const [noonAllSlots, setNoonAllSlots] = useState(false);
  const [eveningAllSlots, setEveningAllSlots] = useState(false);
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

  const navigate = useNavigate();
  const loadingMessages = [
    "Finding nearby physiotherapists…",
    "Checking availability for your location…",
    "Matching therapists for this pincode…",
    "Fetching available time slots…",
    "Verifying travel feasibility…",
    "Finalising suitable slots for you…",
  ];

  const mergeBlockedFlags = (currentSlotsByDate, blockedSlotsByDate) => {
    const next = { ...currentSlotsByDate };
    const normalizedBlocked = normalizeSlotsByDate(blockedSlotsByDate);

    Object.entries(normalizedBlocked || {}).forEach(([date, blockedSlots]) => {
      if (!Array.isArray(blockedSlots) || !Array.isArray(next[date])) return;
      // primary map (time + therapist) and fallback map (time only) so we still mark a slot
      // even if the backend sends a different therapist_id for the same timestamp.
      const blockedMap = new Map();
      const blockedByTimeOnly = new Map();
      blockedSlots.forEach((slot) => {
        const key = `${slot.epochMs}|${slot.therapist_id}`;
        blockedMap.set(key, slot.blocked ?? false);
        if (slot.epochMs != null) blockedByTimeOnly.set(slot.epochMs, slot.blocked ?? false);
      });
      next[date] = next[date].map((slot) => {
        const key = `${slot.epochMs}|${slot.therapist_id}`;
        if (blockedMap.has(key)) {
          return { ...slot, blocked: blockedMap.get(key) };
        }
        // fallback: match by time only if therapist_id differs
        if (blockedByTimeOnly.has(slot.epochMs)) {
          return { ...slot, blocked: blockedByTimeOnly.get(slot.epochMs) };
        }
        return slot;
      });
    });
    return next;
  };

  const getTherapistFromPinCode = async () => {
    setLoader(true);
    try {
      const getUser = sessionStorage.getItem("user");
      const { pinCode } = JSON.parse(getUser);
      const apiPath = `${getAllTherapist}?pinCode=${pinCode}`;
      console.log("[SlotPage] Fetch therapists API request:", {
        method: "GET",
        url: `${instance.defaults.baseURL}${apiPath}`,
        pinCode,
      });
      const response = await instance.get(apiPath);
      const therapists = response?.data?.therapists || [];
      console.log("[SlotPage] Fetch therapists API response:", response.data);
      console.log("[SlotPage] API therapists count:", therapists.length);
      setTherapists(therapists);
    } catch (error) {
      console.error("[SlotPage] Fetch therapists API error:", error);
    } finally {
      setLoader(false);
    }
  };

  const getTimeSlotTherapist = async () => {
    const fetchKey = ++latestFetchKeyRef.current;

    setLoader(true);
    try {
      const apiStartDate = today.toISOString().split("T")[0]; // always start from today
      console.log("[TherapistSlots] request", {
        doctorId: selectedDoctorId,
        startDate: apiStartDate,
        pincode: pinCode,
      });
      const response = await instance.post(getTherapistInternalBooking, {
        doctor_id: selectedDoctorId,
        start_date: apiStartDate,
        pincode: pinCode,
      });

      // capture requestId for per-doctor blocked polling if provided
      const doctorReqId = response?.data?.requestId || null;
      setTherapistBlockedRequestId(doctorReqId);
      // doctorReqId may be null; polling will skip in that case

      const slotsArray = response?.data?.data?.availability_by_date || [];
      const nextMap = {};
      slotsArray.forEach((day) => {
        nextMap[day.date] = (day.slots || []).map((slot) => ({
          time: slot.start_at,
          epochMs: slot.start_at ? new Date(slot.start_at).getTime() : null,
          available: true,
          blocked: false,
          therapist_id: selectedDoctorId,
        }));
      });
      // Single diagnostic log for therapist view
      // Detailed diagnostics for a single therapist selection
      console.log("[TherapistSlots] normalized", {
        doctorId: selectedDoctorId,
        startDate: apiStartDate,
        requestId: doctorReqId,
        slotsByDate: nextMap,
      });

      // If another request started later, ignore this one
      if (fetchKey !== latestFetchKeyRef.current) return;

      // Merge into therapist bucket without touching ALL bucket
      setTherapistSlotsByDate((prev) => ({ ...prev, ...nextMap }));
      // Build/merge DateCard flags
      const timingUpdates = Object.keys(nextMap).map((d) => ({
        date: d,
        slots: (nextMap[d] || []).length > 0,
      }));
      setAllAvailable((prev) => {
        const copy = [...prev];
        timingUpdates.forEach((t) => {
          const idx = copy.findIndex((m) => m.date === t.date);
          if (idx > -1) copy[idx] = t;
          else copy.push(t);
        });
        return copy;
      });
    } catch (e) {
    } finally {
      setLoader(false);
    }
  };







  const getAllTherapistTimeSlot = async () => {
    setLoader(true);
    try {
      const { pinCode } = JSON.parse(sessionStorage.getItem("user"));
      const response = await instance.post(getAllTherapistInternalBooking, {
        pincode: pinCode,
      });

      const timeSlotsData = response?.data?.timeSlots || {};
      const requestId = response?.data?.requestId || null;
      const normalizedTimeSlotsData = normalizeSlotsByDate(timeSlotsData);
      if (!Object.keys(timeSlotsData).length) {
        sessionStorage.setItem("redirectedFromSlotPage", "true");
        navigate(`/${partnerSlug ? partnerSlug + "/" : ""}request-slot`);

        return;
      }

      // Only set selectedDate the very first time we load ALL slots
      if (isFirstAllFetch.current) {
        const firstDate = Object.keys(timeSlotsData)[0];
        setselectedDate((prev) => prev || firstDate);
        isFirstAllFetch.current = false;
      }

      // Build DateCard flags
      const timing = Object.entries(normalizedTimeSlotsData).map(([currentDate, currentSlots]) => ({
        date: currentDate,
        slots: Array.isArray(currentSlots) && currentSlots.length > 0,
      }));

      // STORE to ALL bucket
      setAllTimeSlotsByDate(normalizedTimeSlotsData);
      setAllAvailable(timing);
      setBlockedRequestId(requestId);
      // requestId may be null; polling will skip in that case
    } catch (e) {
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    const wasRedirected = sessionStorage.getItem("redirectedFromSlotPage");

    if (wasRedirected) {
      // Clear the flag so it doesn't affect future visits
      sessionStorage.removeItem("redirectedFromSlotPage");

      return; // Prevent the function from running again
    }

    getAllTherapistTimeSlot();
  }, []);

  useEffect(() => {
    if (!blockedRequestId) return;

    const pollIntervalMs = 1500;
    const timeoutMs = 25000;
    const startAt = Date.now();
    let cancelled = false;

    const pollBlockedStatus = async () => {
      if (cancelled) return;
      try {
        const response = await instance.get(
          `/blockedSlotsStatus?requestId=${blockedRequestId}`
        );
        const status = response?.data?.status;
        if (status === "pending") {
          if (Date.now() - startAt >= timeoutMs) {
            return;
          }
          blockedPollTimeoutRef.current = setTimeout(pollBlockedStatus, pollIntervalMs);
          return;
        }
        if (status === "done") {
          const blockedSlotsData =
            response?.data?.result?.timeSlots ||
            response?.data?.timeSlots ||
            response?.data?.blockedSlots ||
            {};
          if (!Object.keys(blockedSlotsData || {}).length) {
            return;
          }
          setAllTimeSlotsByDate((prev) => mergeBlockedFlags(prev, blockedSlotsData));
          setTherapistSlotsByDate((prev) => mergeBlockedFlags(prev, blockedSlotsData));
          return;
        }
      } catch (error) {
      }
    };

    pollBlockedStatus();

    return () => {
      cancelled = true;
      if (blockedPollTimeoutRef.current) {
        clearTimeout(blockedPollTimeoutRef.current);
        blockedPollTimeoutRef.current = null;
      }
    };
  }, [blockedRequestId]);

  // Poll blocked slots for single-therapist fetches (if backend returns requestId)
  useEffect(() => {
    if (!therapistBlockedRequestId) return;

    const pollIntervalMs = 1500;
    const timeoutMs = 25000;
    const startAt = Date.now();
    let cancelled = false;

    const pollBlockedStatus = async () => {
      if (cancelled) return;
      try {
        const response = await instance.get(
          `/blockedSlotsStatus?requestId=${therapistBlockedRequestId}`
        );
        const status = response?.data?.status;
        if (status === "pending") {
          if (Date.now() - startAt >= timeoutMs) {
            return;
          }
          therapistBlockedPollTimeoutRef.current = setTimeout(pollBlockedStatus, pollIntervalMs);
          return;
        }
        if (status === "done") {
          const blockedSlotsData =
            response?.data?.result?.timeSlots ||
            response?.data?.timeSlots ||
            response?.data?.blockedSlots ||
            {};
          if (!Object.keys(blockedSlotsData || {}).length) {
            return;
          }
          console.log("[TherapistSlots] blocked merge", {
            requestId: therapistBlockedRequestId,
            blockedSlotsData,
          });
          setTherapistSlotsByDate((prev) => mergeBlockedFlags(prev, blockedSlotsData));
          return;
        }
      } catch (error) {
      }
    };

    pollBlockedStatus();

    return () => {
      cancelled = true;
      if (therapistBlockedPollTimeoutRef.current) {
        clearTimeout(therapistBlockedPollTimeoutRef.current);
        therapistBlockedPollTimeoutRef.current = null;
      }
    };
  }, [therapistBlockedRequestId]);

  useEffect(() => {
    if (!loader) return;
    const intervalId = setInterval(() => {
      setLoadingMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 200);
    return () => clearInterval(intervalId);
  }, [loader, loadingMessages.length]);


  const formatDateToReadable = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();

    const month = date.toLocaleString("default", { month: "long" });

    // Function to get ordinal suffix (st, nd, rd, th)
    const getOrdinal = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
    };

    return `${month} ${day}${getOrdinal(day)}, ${year}`;
  };

  useEffect(() => {
    getTherapistFromPinCode();
  }, []);

  useEffect(() => {
    console.log("[SlotPage] Therapists rendered in UI:", Therapist?.length || 0);
  }, [Therapist]);

  // When selectedDoctorId changes: fetch therapist slots once (start_date pinned to today)
  useEffect(() => {
    if (!selectedDoctorId) return;
    getTimeSlotTherapist();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDoctorId]);



  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 20000);  // 5000 milliseconds = 5 seconds

    return () => clearTimeout(timer);  // Clean up the timer when the component unmounts or rerenders
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);  // Function to close the popup
  };


  const resolveDoctorFromSlot = (slot) => {
    const slotId = String(slot?.therapist_id ?? "");
    return Therapist.find((t) => {
      const ids = [
        t?.doctor_id,
        t?.homevisit_resource_id,
        t?.dayschedule_id,
      ]
        .filter(Boolean)
        .map(String);
      return ids.includes(slotId);
    });
  };

  const handleTimeSlotSelection = (timeSlot) => {
    const resolvedDoctor = resolveDoctorFromSlot(timeSlot);
    setSelectedTimeSlot(timeSlot);
    if (!selectedDoctorId) {
      setSelectedAllDoctorId(resolvedDoctor?.doctor_id || timeSlot.therapist_id);
      setSelectedDoctorMeta(resolvedDoctor || null);
    }

    mixpanel.track("Button Clicked - Time Slot", {
      "Selected Time Slot": timeSlot.time,
      "Therapist ID": timeSlot.therapist_id,
      "Available": timeSlot.available ? 'Yes' : 'No'  // Assuming 'available' is a boolean property of timeSlot
    });
  };

  const handleTherapistClick = (therapist) => {
    setSelectedTimeSlot(null);
    setTherapistSlotsByDate({}); // clear SINGLE bucket so no stale slots render
    setSelectedDoctorId(therapist.doctor_id);
    setSelectedAllDoctorId(null);
    setSelectedDoctorMeta(therapist);
    mixpanel.track("Therapist Card Clicked", { "Therapist Name": therapist.doctor_name, "Therapist ID": therapist.doctor_id });
  };


  const renderAllTimeSlots = useMemo(
    () => (startTime, endTime) => {
      if (!allTimeSlotsByDate || !selectedDate) return [];
      const filtered = (allTimeSlotsByDate[selectedDate] || [])
        .filter((s) => {
          const h = new Date(s.time).getHours();
          return h >= startTime && h < endTime;
        })
        .slice()
        .sort((a, b) => new Date(a.time) - new Date(b.time)); // ensure chronological order
      return filtered.map((timeSlot) => (
        <TimeSlotCard
          key={timeSlot.time}
          time={timeSlot.time}
          available={timeSlot.available}
          blocked={timeSlot.blocked}
          isSelected={selectedTimeSlot?.time === timeSlot.time}
          onClick={() => handleTimeSlotSelection(timeSlot)}
        />
      ));
    },
    [allTimeSlotsByDate, selectedDate, selectedTimeSlot]
  );


  const renderTimeSlots = useMemo(
    () => (startTime, endTime) => {
      const slots = therapistSlotsByDate[selectedDate] || [];
      return slots
        .filter((s) => {
          const h = new Date(s.time).getHours();
          return h >= startTime && h < endTime;
        })
        .slice()
        .sort((a, b) => new Date(a.time) - new Date(b.time)) // ensure chronological order
        .map((slot) => (
          <TimeSlotCard
            key={slot.time}
            time={slot.time}
            available={slot.available}
            blocked={slot.blocked}
            isSelected={selectedTimeSlot?.time === slot.time}
            onClick={() => handleTimeSlotSelection(slot)}
          />
        ));
    },
    [therapistSlotsByDate, selectedDate, selectedTimeSlot]
  );

  const getActiveSlotsForDate = () => {
    return selectedDoctorId
      ? (therapistSlotsByDate[selectedDate] || [])
      : (allTimeSlotsByDate[selectedDate] || []);
  };

  useEffect(() => {
    const slots = getActiveSlotsForDate();
    const hasInWindow = (start, end) =>
      slots.some((s) => {
        const h = new Date(s.time).getHours();
        return h >= start && h < end;
      });

    setMorningSlots(hasInWindow(8, 12));
    setNoonSlots(hasInWindow(12, 16));
    setEveningSlots(hasInWindow(16, 21));
  }, [selectedDoctorId, selectedDate, allTimeSlotsByDate, therapistSlotsByDate]);



  useEffect(() => {
    if (
      Array.isArray(allTimeSlotsByDate[selectedDate]) &&
      allTimeSlotsByDate[selectedDate]
    ) {
      setMorningAllSlots(
        allTimeSlotsByDate[selectedDate].some((timeSlot) => {
          const hour = new Date(timeSlot.time).getHours();
          return hour >= 9 && hour < 12;
        })
      );

      setNoonAllSlots(
        allTimeSlotsByDate[selectedDate].some((timeSlot) => {
          const hour = new Date(timeSlot.time).getHours();
          return hour >= 12 && hour < 16;
        })
      );

      setEveningAllSlots(
        allTimeSlotsByDate[selectedDate].some((timeSlot) => {
          const hour = new Date(timeSlot.time).getHours();
          return hour >= 16 && hour < 21;
        })
      );
    }
  }, [allAvailable, selectedDate]);

  const handleProceed = () => {
    if (selectedTimeSlot) {
      const doctorIdToUse = selectedDoctorId || selectedAllDoctorId || selectedTimeSlot?.therapist_id;
      const resolvedNameFromList = Therapist.find(
        (t) => String(t?.doctor_id) === String(doctorIdToUse)
      )?.doctor_name;
      const therapistNameToPass = selectedDoctorMeta?.doctor_name || resolvedNameFromList || null;

      navigate(`/${partnerSlug ? partnerSlug + "/" : ""}booking-detail`, {
        state: {
          therapistId: doctorIdToUse,
          timing: selectedTimeSlot,
          therapistName: therapistNameToPass,
          isBlockedSlot: selectedTimeSlot.blocked || false, // dY`^ add this line
        },
      });

      mixpanel.track("Button Clicked - Proceed to Booking Detail", {
        "Doctor ID": doctorIdToUse,
        "Selected Time Slot": selectedTimeSlot.time,
        "Date": selectedDate,
        "Blocked Slot": selectedTimeSlot.blocked ? "Yes" : "No", // dY`^ track it too
      });
    }
  };



  const handleAllTherapistTime = () => {
    setSelectedTimeSlot(null);
    setSelectedDoctorId(null);
    setSelectedDoctorMeta(null);
    // Always refresh the aggregated availability when All is selected
    getAllTherapistTimeSlot();
    mixpanel.track("Button Clicked - All Available");
  };


  const handleChooseTherapistClick = () => {
    setShowTherapistSection(!showTherapistSection);
  };

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const renderSlotsSkeleton = (showMessage = false) => (
    <Box sx={{ position: "relative" }}>
      <style>
        {`
          .skeleton-bright::after {
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
          }
        `}
      </style>
      {/*
        {showMessage && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              pt: 2,
              pointerEvents: "none",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                px: 1.5,
                py: 0.75,
                borderRadius: 1.5,
                bgcolor: "rgba(255, 255, 255, 0.6)",
                backdropFilter: "blur(2px)",
              }}
            >
              <Typography variant="body1" sx={{ color: "#3d4045ff",  fontWeight: 600, fontSize: '18px' }}>
                {loadingMessages[loadingMessageIndex]}
              </Typography>
            </Box>
          </Box>
        )}
      */}
     
      {["Morning", "Noon", "Evening"].map((label) => (
        <div className="MorningDiv" key={label}>
          <div className="MorningDivHeading">
            <Typography variant="body1">
              <Skeleton width={120} animation="wave" sx={{ bgcolor: "#F1F1F1" }} className="skeleton-bright" />
            </Typography>
            <Typography variant="caption">
              <Skeleton width={160} animation="wave" sx={{ bgcolor: "#F1F1F1" }} className="skeleton-bright" />
            </Typography>
          </div>
          <div className="TimeSlots">
            {Array.from({ length: 8 }).map((_, idx) => (
              <Box key={`${label}-${idx}`} sx={{ mr: 2, mb: 2 }}>
                <Skeleton variant="rounded" width={90} height={36} animation="wave" sx={{ bgcolor: "#F1F1F1" }} className="skeleton-bright" />
              </Box>
            ))}
          </div>
        </div>
      ))}
    </Box>
  );

  const renderDateSkeleton = () => (
    <div className="TherapistCards DateCardWrapper2">
      {Array.from({ length: 3 }).map((_, idx) => (
        <Box key={`date-skel-${idx}`} sx={{ mr: 2, mb: 2 }}>
          <Skeleton variant="rounded" width={90} height={70} animation="wave" sx={{ bgcolor: "#F1F1F1" }} className="skeleton-bright" />
        </Box>
      ))}
    </div>
  );





  return (
    <>
      {showPopup && <Popup onClose={handleClosePopup} />}
      <div className="BookingContainer">
        <div
          className="BookingWrapper"
          style={{
            backgroundImage: `url(${require("../assets/images/BackgroundBig.png")})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <BackHeader onBack={handleBackButtonClick} />
          <StepIndicator step={2} totalSteps={4} header="Select A Time Slot" />
          <AboutPhysica
            handleChooseTherapistClick={handleChooseTherapistClick}
            setShowMore={setShowMore}
            showMore={showMore}
            pinCode={pinCode}
          />
          {showTherapistSection && (
            <div className="ChooseTherapistContainer">
              <h1>Select A Therapist (Optional)</h1>
              <div className="ChooseTherapistWrapper">
                <div
                  className={
                    selectedAllDoctorId ||
                      (!selectedDoctorId &&
                        allTimeSlotsByDate[selectedDate]?.length > 0)
                      ? "AllTherapist selectedCard"
                      : "AllTherapist"
                  }
                  onClick={() => handleAllTherapistTime()}
                >
                  <p>ALL</p>
                  <p>Available</p>
                </div>
                <div
                  className="TherapistCards"
                  ref={ref}
                  onMouseDown={onMouseDown}
                  onMouseLeave={onMouseLeave}
                  onMouseUp={onMouseUp}
                  onMouseMove={onMouseMove}
                >
                  {Therapist?.map((item) => (
                    <TherapistCard
                      key={item.doctor_id}
                      setSelectedDoctorId={setSelectedDoctorId}
                      item={item}
                      onClick={() => handleTherapistClick(item)}
                      selectedDoctorId={selectedDoctorId}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}

          <SessionDetail />

          <div className="ChooseTherapistContainer">
            <h1>1. Select a Date</h1>
            {loader ? (
              renderDateSkeleton()
            ) : (
              <div className="TherapistCards DateCardWrapper2">
                {allAvailable?.map((slot) => (
                  <DateCard
                    selectedDate={selectedDate}
                    key={slot.date}
                    data={slot}
                    setselectedDate={setselectedDate}
                    allTimeSlotsByDate={allTimeSlotsByDate}
                  />
                ))}
              </div>
            )}
          </div>

          {selectedDoctorId ? (
            <div className="TimingHeading">
              {loader ? (
                renderSlotsSkeleton(true)
              ) : (
                <>
                  <h1>2. Select Available Slot</h1>
                  <h2 className="Datesunheading">
                    Showing slots for:{" "}
                    <span className="text-partner">

                      {formatDateToReadable(selectedDate)}
                    </span>
                  </h2>
                  {morningSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Morning</p>
                        <p>8:00 AM- 12:00PM</p>
                      </div>
                      <div className="TimeSlots">{renderTimeSlots(8, 12)}</div>
                    </div>
                  )}
                  {noonSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Noon</p>
                        <p>12:00 PM- 4:00PM</p>
                      </div>
                      <div className="TimeSlots">{renderTimeSlots(12, 16)}</div>
                    </div>
                  )}
                  {eveningSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Evening</p>
                        <p>4:00 PM- 9:00PM</p>
                      </div>
                      <div className="TimeSlots">{renderTimeSlots(16, 21)}</div>
                    </div>
                  )}
                </>
              )}
            </div>
          ) : (
            <div className="TimingHeading">
              <h1>2. Select Available Slot</h1>
              <h2 className="Datesunheading">
                Showing slots for:{" "}
                <span className="text-partner">
                  {formatDateToReadable(selectedDate)}
                </span>
              </h2>

              {Object.keys(allTimeSlotsByDate).length === 0 ? (
                renderSlotsSkeleton(true)
              ) : (
                <>
                  {morningAllSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Morning</p>
                        <p>8:00 AM - 12:00 PM</p>
                      </div>
                      <div className="TimeSlots">{renderAllTimeSlots(8, 12)}</div>
                    </div>
                  )}

                  {noonAllSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Noon</p>
                        <p>12:00 PM - 4:00 PM</p>
                      </div>
                      <div className="TimeSlots">{renderAllTimeSlots(12, 16)}</div>
                    </div>
                  )}

                  {eveningAllSlots && (
                    <div className="MorningDiv">
                      <div className="MorningDivHeading">
                        <p>Evening</p>
                        <p>4:00 PM - 9:00 PM</p>
                      </div>
                      <div className="TimeSlots">{renderAllTimeSlots(16, 23)}</div>
                    </div>
                  )}
                </>
              )}
            </div>
          )}


          {/* ✅ FINAL BUTTON after all slots */}
          <div className="flex justify-center mt-4">
            <button
              className={`offer-gradient text-center text-white font-semibold text-lg px-6 py-2 my-4 rounded-xl ${selectedTimeSlot ? "" : "opacity-50 cursor-not-allowed"}`}
              disabled={!selectedTimeSlot}
              onClick={handleProceed}
            >
              <span className="flex items-center gap-2">
                Continue to Booking Details
                <img
                  src={rightIcon}
                  alt="arrow"
                  className="w-6 h-5 invert brightness-0"
                />
              </span>
            </button>

          </div>
        </div>
      </div>
    </>
  );

};

export default SlotPage;
